module.exports = __webpack_public_path__ + "08e15bf6e740503f849ab7211ac7aede.svg";